import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { H1, TextSmall } from '@components/Typography/Typography';
import { Picture } from '@components/ui/Picture/Picture';

import { Close } from '@/components/ui/Close/Close';

import { ModalContext } from '../Modal/config';

import { Background } from './Background/Background';
import { GameItemInfo } from './GameItemInfo/GameItemInfo';
import { TGemsDiceInfo } from './TGemsDiceInfo/TGemsDiceInfo';

import css from './styles.module.scss';

import casePng from '/img/case-huge.png';
import caseWebp from '/img/case-huge.webp';

const ChestInfo: FC = () => {
  const { closeModal } = useContext(ModalContext);
  const { t } = useTranslation();

  return (
    <div className="relative w-full pt-14 sm-h:pb-6 pb-12 px-4">
      <Background />
      <Close
        onClick={closeModal}
        className={'absolute top-4 right-4 backdrop-blur-sm'}
        variant="modal"
        imageVariant="modal"
      />
      <div className="w-full flex flex-col items-center relative z-[2]">
        <div className="relative w-32 h-32 mb-[0.375rem]">
          <Picture
            className={css.case}
            img={casePng}
            webp={caseWebp}
            alt="case"
          />
          <div className={css.smallEllipse}></div>
        </div>
        <H1 weight="black" className="mb-2">
          {t('Container Drops')}
        </H1>
        <TextSmall
          weight="regular"
          className="!text-white/60 !leading-1.3 text-center max-w-[285px] mb-6"
        >
          {t(
            'Complete contracts to get rewards! T-Gem and Dice drops alternate basedon the arena competition phase',
          )}
        </TextSmall>
        <div className="w-full flex flex-col gap-2">
          <GameItemInfo />
          <TGemsDiceInfo variant="dice" />
        </div>
      </div>
    </div>
  );
};

export { ChestInfo };
